<template>
  <div v-if="noContent">
    <div class="row">
      <div class="col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo" v-if="showContent">{{ title }}</h2>
        <div class="" v-if="showContent">
          <ul id="galeria_videos">
            <li v-for="(item, index) in items" @click="setVideoShow(item.codevideo)">
              <img v-if="item.image" :src="item.image">
              <img v-if="!item.image" src="dist/images/sem_imagem.jpg"/>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade modal_videos" id="myModal" role="dialog" ref="vuemodal">
      <div class="modal-dialog">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-content embed-responsive embed-responsive-16by9" role="dialog">
          <iframe class="embed-responsive-item" :src="urlShowVideo"></iframe>
        </div>

      </div>
    </div>

  </div>
</template>
<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';

  export default {
    components: {
      Loading
    },
    props: ['bloco'],
    data() {
      return {
        title: 'Galeria de vídeo',
        showContent: true,
        items: [],
        noContent: true,
        urlShowVideo: ''
      }
    },
    mounted() {
      $(this.$refs.vuemodal).on("hidden.bs.modal", this.onHidden)
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      let self = this;
      // get('content/' + this.bloco.id).then(function (response) {
      self.showContent = true;
      // self.items = response.data.result.data;
      self.items = this.$store.getters['getSiteContent'].result.data.video;
      // self.items = window.siteconfig.result.data.video;
      // });
    },
    watch: {
      items(items) {
        if (items.length === 0) {
          this.noContent = false;
        }
      }
    },
    methods: {
      setVideoShow(video) {
        $('#myModal').modal();
        this.urlShowVideo = "https://www.youtube.com/embed/" + video;
        return this.urlShowVideo;
      },
      onHidden() {
        this.urlShowVideo = null;
        $("#myModal iframe").attr("src", $("#myModal iframe").attr("src"));
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/VideoGalleryList.vue